import * as Blockly from 'blockly/core'
import 'blockly/blocks'
import 'blockly/javascript'
import * as En from 'blockly/msg/en'
import { GRID } from '@tm/shared'
import { tmBlocklyTheme } from './theme.js'
import { registerEventBlocks } from './blocks/events.js'
import { registerMotionBlocks } from './blocks/motion.js'
import { registerLooksBlocks } from './blocks/looks.js'
import { registerSoundBlocks } from './blocks/sound.js'
import { registerLogicBlocks } from './blocks/logic.js'
import { registerLoopBlocks } from './blocks/loop.js'
import { registerEndBlocks } from './blocks/end.js'
import { createToolboxForTemplate } from './toolbox.js'

let registered = false
let localeSet = false

export function createWorkspace(blocklyDiv, { availableBlocks } = {}) {
  if (!localeSet) {
    Blockly.setLocale(En)
    localeSet = true
  }
  if (!registered) {
    registerEventBlocks()
    registerMotionBlocks()
    registerLooksBlocks()
    registerSoundBlocks()
    registerLogicBlocks()
    registerLoopBlocks()
    registerEndBlocks()
    registered = true
  }

  const isMobile = window.matchMedia('(max-width: 768px)').matches

  const workspace = Blockly.inject(blocklyDiv, {
    toolbox: createToolboxForTemplate(availableBlocks),
    renderer: 'thrasos',
    theme: tmBlocklyTheme,
    grid: {
      spacing: GRID.spacing,
      length: GRID.length,
      colour: GRID.colour,
      snap: GRID.snap,
    },
    zoom: {
      controls: !isMobile,
      wheel: !isMobile,
      pinch: true,
      startScale: isMobile ? 0.85 : 1.0,
      maxScale: 2.0,
      minScale: 0.5,
      scaleSpeed: 1.1,
    },
    trashcan: !isMobile,
    horizontalLayout: false,
    toolboxPosition: isMobile ? 'top' : 'start',
    sounds: false,
    readOnly: false,
    rtl: false,
    oneBasedIndex: true,
    scrollbars: true,
    move: { scrollbars: true, drag: true, wheel: false },
  })

  // Pastikan flyout workspace bersifat read-only sehingga drag dari toolbox
  // membuat salinan di workspace utama, bukan memindahkan blok asli.
  const flyoutWorkspace = workspace.getFlyout()?.getWorkspace()
  if (flyoutWorkspace) {
    flyoutWorkspace.options.readOnly = true
    if (flyoutWorkspace.options.moveOptions) {
      flyoutWorkspace.options.moveOptions.drag = false
    }
  }

  return workspace
}
